

import { initializeApp } from 'firebase/app';
import { getMetadata, getStorage, listAll, ref, uploadBytesResumable } from 'firebase/storage';
import getFirebaseConf from './firebaseConf';
import { FileTag } from '../types';


const app = initializeApp(getFirebaseConf());
const storage = getStorage(app)


export const uploadToStorage = async (file: any, path: string, tags?: Record<string, string>, isReplaceFile?: boolean,) => {

    if (file) {

        const listRef = ref(storage, path);

        // Create timestamped filename
        const timestamp = Date.now();
        /// isReplaceFile is used to crop image 
        const newFileName = isReplaceFile ? `${file.name}` : `${timestamp}_${file.name}`;

        // Create a new File object with the renamed file name
        const renamedFile = new File([file], newFileName, { type: file.type });

        let metadata = {};
        if (tags) {
            // tags.forEach((tag) => {
            //     metadata = { ...metadata, [tag]: true }
            // });
            metadata = { "customMetadata": { ...tags } }
        }
        return await uploadBytesResumable(ref(listRef, newFileName), renamedFile, metadata);
    }

}
export const fileHasKFHConsentTag = async (path: string,) => {

    const folderRef = ref(storage, path);

    try {
        const listResult = await listAll(folderRef);

        // Loop over each item (file) in the folder
        for (const itemRef of listResult.items) {
            try {
                const metadata = await getMetadata(itemRef);
                const customMetadata = metadata.customMetadata || {};

                // Check if the tag exists (and matches the value if provided)
                if (customMetadata["kfhConsent"] !== undefined) {

                    return true;

                }
            } catch (error) {
                console.error('Error getting metadata for file:', itemRef.fullPath, error);
            }
        }
        return false;


    } catch (error: any) {
        if (error?.code === 'storage/object-not-found') {
            console.error('not found:', error);

        } else {
            console.error('Error checking file:', error);
        }
        return false;
    }

}


export const fileHasTag = async (path: string, tag: FileTag) => {

    const folderRef = ref(storage, path);

    try {
        const listResult = await listAll(folderRef);

        // Loop over each item (file) in the folder
        for (const itemRef of listResult.items) {
            try {
                const metadata = await getMetadata(itemRef);
                const customMetadata = metadata.customMetadata || {};

                // Check if the tag exists (and matches the value if provided)
                return Object.keys(customMetadata).includes(tag);
            } catch (error) {
                console.error('Error getting metadata for file:', itemRef.fullPath, error);
            }
        }
        return false;


    } catch (error: any) {
        if (error?.code === 'storage/object-not-found') {
            console.error('not found:', error);

        } else {
            console.error('Error checking file:', error);
        }
        return false;
    }

} 